import React, { useState } from 'react';

const API = 'https://tribaltech-backend.onrender.com';
// 2026-10-19 security fix: no bundled admin key. Reads the session's
// typed password from sessionStorage (stashed by Admin.js PasswordGate
// after a 200 from GET /api/admin/whoami). The compiled bundle contains
// no secret.
const adminKey = () => sessionStorage.getItem('cp_admin_key') || '';

const S = {
  wrap: { marginBottom: 20 },
  panel: { background: '#0f0f1e', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 10, padding: '18px 20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 },
  title: { fontSize: 12, fontWeight: 600, color: '#aaa', letterSpacing: '0.06em', textTransform: 'uppercase' },
  row: { display: 'flex', gap: 10, marginBottom: 16 },
  input: { flex: 1, background: '#080810', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 6, padding: '9px 14px', fontSize: 13, color: '#fff', fontFamily: 'inherit', outline: 'none' },
  btn: { background: '#A78BFA', color: '#fff', border: 'none', borderRadius: 6, padding: '9px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  btnSm: { background: 'rgba(255,255,255,0.05)', color: '#aaa', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 12 },
  th: { textAlign: 'left', padding: '6px 10px', color: '#555', fontSize: 10, letterSpacing: '0.07em', textTransform: 'uppercase', borderBottom: '1px solid rgba(255,255,255,0.06)' },
  td: { padding: '9px 10px', color: '#ccc', borderBottom: '1px solid rgba(255,255,255,0.04)' },
  empty: { color: '#555', fontSize: 12, padding: '16px 0', textAlign: 'center' },
  userPanel: { marginTop: 16, padding: 16, background: 'rgba(167,139,250,0.06)', border: '1px solid rgba(167,139,250,0.15)', borderRadius: 8 },
  userEmail: { fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 },
  userMeta: { fontSize: 11, color: '#666', marginBottom: 14 },
  scanRow: { display: 'flex', gap: 10, marginBottom: 12 },
  scanInput: { flex: 1, background: '#080810', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 6, padding: '7px 12px', fontSize: 12, color: '#fff', fontFamily: 'inherit', outline: 'none' },
  success: { padding: '8px 12px', background: 'rgba(52,211,153,0.1)', borderRadius: 6, fontSize: 12, color: '#34D399', marginBottom: 12 },
  error: { padding: '8px 12px', background: 'rgba(239,68,68,0.1)', borderRadius: 6, fontSize: 12, color: '#EF4444', marginBottom: 12 },
};

function fmtDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' });
}

export default function CreatorSearch() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [leaks, setLeaks] = useState(null);
  const [leaksLoading, setLeaksLoading] = useState(false);
  const [scanUsernames, setScanUsernames] = useState('tribalbbc,theonlytribal');
  const [scanLoading, setScanLoading] = useState(false);
  const [scanMsg, setScanMsg] = useState(null);

  const search = async () => {
    if (!query.trim()) return;
    setLoading(true);
    setResults(null);
    setSelected(null);
    setLeaks(null);
    try {
      const resp = await fetch(`${API}/api/admin/users/search?q=${encodeURIComponent(query.trim())}`, {
        headers: { 'x-admin-key': adminKey() }
      });
      const data = await resp.json();
      setResults(data.creators || []);
    } catch (e) {
      setResults([]);
    }
    setLoading(false);
  };

  const selectUser = async (creator) => {
    setSelected(creator);
    setLeaks(null);
    setScanMsg(null);
    setLeaksLoading(true);
    try {
      const resp = await fetch(`${API}/api/admin/users/${creator.id}/leaks`, {
        headers: { 'x-admin-key': adminKey() }
      });
      const data = await resp.json();
      setLeaks(data);
    } catch (e) {
      setLeaks({ leaks: [], total: 0, dmca_filed: 0 });
    }
    setLeaksLoading(false);
  };

  const triggerScan = async () => {
    if (!selected) return;
    setScanLoading(true);
    setScanMsg(null);
    try {
      const usernames = scanUsernames.split(',').map(u => u.trim()).filter(Boolean);
      const resp = await fetch(`${API}/api/admin/users/${selected.id}/scan`, {
        method: 'POST',
        headers: { 'x-admin-key': adminKey(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ usernames })
      });
      const data = await resp.json();
      setScanMsg({ success: data.success, text: data.success ? `Scan triggered for ${usernames.join(', ')}` : data.error });
    } catch (e) {
      setScanMsg({ success: false, text: e.message });
    }
    setScanLoading(false);
  };

  return (
    <div style={S.wrap}>
      <div style={S.panel}>
        <div style={S.header}>
          <span style={S.title}>Creator Search</span>
          <span style={{ fontSize: 11, color: '#555' }}>Search by email or username</span>
        </div>

        <div style={S.row}>
          <input
            style={S.input}
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && search()}
            placeholder="email, username, or platform..."
            autoFocus
          />
          <button style={S.btn} onClick={search} disabled={loading}>
            {loading ? 'Searching...' : 'Search'}
          </button>
        </div>

        {results && results.length === 0 && (
          <p style={S.empty}>No creators found</p>
        )}

        {results && results.length > 0 && (
          <table style={S.table}>
            <thead>
              <tr>
                {['Email', 'Plan', 'Status', 'Joined'].map(h => (
                  <th key={h} style={S.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {results.map((c, i) => (
                <tr
                  key={c.id}
                  style={{ background: selected?.id === c.id ? 'rgba(167,139,250,0.08)' : i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.02)', cursor: 'pointer' }}
                  onClick={() => selectUser(c)}
                >
                  <td style={{ ...S.td, color: '#A78BFA' }}>{c.email || '—'}</td>
                  <td style={S.td}>{c.plan || '—'}</td>
                  <td style={S.td}>
                    <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 4, fontWeight: 600, ...(c.stripe_customer_id ? { background: '#16a34a22', color: '#4ade80' } : { background: '#71717a22', color: '#a1a1aa' }) }}>
                      {c.stripe_customer_id ? 'active' : 'free'}
                    </span>
                  </td>
                  <td style={S.td}>{fmtDate(c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {selected && (
          <div style={S.userPanel}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={S.userEmail}>{selected.email}</div>
                <div style={S.userMeta}>{selected.plan || 'free'} · joined {fmtDate(selected.created_at)}</div>
              </div>
              <button style={S.btnSm} onClick={() => { setSelected(null); setLeaks(null); }}>✕</button>
            </div>

            <div style={S.scanRow}>
              <input
                style={S.scanInput}
                value={scanUsernames}
                onChange={e => setScanUsernames(e.target.value)}
                placeholder="usernames to scan (comma separated)"
              />
              <button style={{ ...S.btn, padding: '7px 16px', fontSize: 12 }} onClick={triggerScan} disabled={scanLoading}>
                {scanLoading ? 'Scanning...' : '🔍 Run Scan'}
              </button>
            </div>

            {scanMsg && (
              <div style={scanMsg.success ? S.success : S.error}>
                {scanMsg.success ? '✓ ' : '✗ '}{scanMsg.text}
              </div>
            )}

            {leaksLoading && <p style={S.empty}>Loading leaks...</p>}

            {leaks && (
              <div>
                <div style={{ display: 'flex', gap: 20, marginBottom: 12, fontSize: 12 }}>
                  <span style={{ color: '#888' }}>Total leaks: <b style={{ color: '#FB923C' }}>{leaks.total}</b></span>
                  <span style={{ color: '#888' }}>DMCAs filed: <b style={{ color: '#34D399' }}>{leaks.dmca_filed}</b></span>
                </div>
                {leaks.leaks.length === 0 ? (
                  <p style={S.empty}>No leaks found for this user</p>
                ) : (
                  <table style={S.table}>
                    <thead>
                      <tr>{['URL', 'Platform', 'Detected', 'DMCA'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
                    </thead>
                    <tbody>
                      {leaks.leaks.slice(0, 20).map((l, i) => {
                        let platform = '—';
                        try { platform = new URL(l.leaked_url).hostname.replace('www.', ''); } catch {}
                        return (
                          <tr key={l.id} style={{ background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.02)' }}>
                            <td style={{ ...S.td, maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              <a href={l.leaked_url} target="_blank" rel="noreferrer" style={{ color: '#4A9EFF', textDecoration: 'none' }}>{l.leaked_url}</a>
                            </td>
                            <td style={S.td}>{platform}</td>
                            <td style={S.td}>{fmtDate(l.detected_at)}</td>
                            <td style={S.td}>{l.dmca_filed_at ? <span style={{ color: '#4ade80' }}>✓</span> : <span style={{ color: '#f87171' }}>✗</span>}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
